/**
 * VIB-720: Widgets-administrasjon som egen menypost.
 *
 * Tidligere bodde widgets-kortet på /innstillinger/tilganger, men det er
 * konseptuelt en annen ting (hva som vises på dashboard) enn rolle-
 * administrasjon. Egen rute gjør sub-menyen lettere å skanne.
 */
import { useImpersonation } from "@/contexts/ImpersonationContext";
import { WidgetsCard } from "@/components/settings/WidgetsCard";
import { SrIcon } from "@/components/ui/SrIcon";

export default function WidgetsSettings() {
  const { activeUser } = useImpersonation();
  // Widgets-redigering = superadmin-only (uendret fra dagens
  // WidgetAdminEditor-policy).
  const canManage = activeUser?.role === "superadmin";

  if (!canManage) {
    return (
      <div className="page-container">
        <p className="text-sm text-muted-foreground">Du har ikke tilgang.</p>
      </div>
    );
  }

  return (
    <div className="page-container animate-fade-in space-y-6">
      <h1 className="font-display font-semibold text-[clamp(28px,3vw,40px)] tracking-[-0.01em] flex items-center gap-2 mb-6">
        <SrIcon name="layout-grid" className="h-6 w-6" />
        Widgets
      </h1>
      <WidgetsCard />
    </div>
  );
}
